import { render, staticRenderFns } from "./1-before-login.vue?vue&type=template&id=04a68da6&scoped=true&"
import script from "./1-before-login.vue?vue&type=script&lang=ts&"
export * from "./1-before-login.vue?vue&type=script&lang=ts&"
import style0 from "./1-before-login.vue?vue&type=style&index=0&id=04a68da6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a68da6",
  null
  
)

export default component.exports